const styles = (theme) => ({
  container: { display: "flex", flexDirection: "column", gap: 1 },
  customTooltip: {
    bgcolor: theme.palette.cardGraphic.graphColor["green"],
    width: "14px",
    height: "14px",
    borderRadius: "2px",
    border: `1px solid ${theme.palette.cardGraphic.graphColor["green"]}`,
  },
  boxTooltip: {
    bgcolor: theme.palette.paletteCharts.lineCharts,
    padding: "8px",
    borderRadius: "8px",
  },
});

export default styles;
